import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from '../../../modules/actions/index';
import * as url from './../../../utils/url';
import axios from './../../../axios';
import MapPositions from './../../../components/OrganizationSetup/MapPositions/MapPositions';
import EnterpriseBreadcrumb from './../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapPositionsManagement extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      const {seniority,occupation} = payload.mapping;
      // console.log(payload.mapping);
      const matchedColumn = [];
      if(seniority.columnName && (seniority.columnName === occupation.columnName)) {
        matchedColumn.push({
          csvField : seniority.columnName,
          value : [{value: "occupations", label: "Occupations"},{value: "seniority", label: "Job Category"}]
        });
      } else {
        if(seniority.columnName) {
          matchedColumn.push({
            csvField : seniority.columnName,
            value : [{value: "seniority", label: "Job Category"}]
          });
        }
        if(occupation.columnName) {
          matchedColumn.push({
            csvField : occupation.columnName,
            value : [{value: "occupations", label: "Occupations"}]
          });
        }
      }
      this.props.onMatchColumn(matchedColumn);
      const occupationData = occupation.data;
      let allOccupationMapping = []
      occupationData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allOccupationMapping = allOccupationMapping.concat(mapping);
      })
      const seniorityData = seniority.data;
      let allSeniorityMapping = []
      seniorityData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allSeniorityMapping = allSeniorityMapping.concat(mapping);
      })
      this.props.saveAllPositionsMapping(allOccupationMapping,allSeniorityMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapPositionsStep();
  }
  handleFileUpload = (columns, data, file) => {
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip positions mapping');
  }

  render() {
    return (
      <div className="mb20 mt60 enterprise-map-page">
        <EnterpriseBreadcrumb 
          linkText="Enterprise Management" 
          link="/home/enterprise-info" 
          activeText="Map Positions"
          {...this.props}
          />
        <MapPositions 
          onProcessedFileUploadData={this.handleFileUpload}
          onMapGenderMatchColumn={this.handleMatchColumn}
          onSkipPositionMapping={this.handleSkipMapping}
          isRepeatFlow={true}
          {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapPositions : state.mapping.positions
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapPositionsStep: () => dispatch(actionCreators.resetMapPositionsStep()),
    nextStep: () => dispatch(actionCreators.mapPositionsNextStep()),
    goBack : () => dispatch(actionCreators.mapPositionsGoBack()),
    reset : () => dispatch(actionCreators.resetPositions()),
    saveAllPositionsMapping : (o,s) => dispatch(actionCreators.saveAllPositionsMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapPositionsUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapPositionsMatchColumnSuccess(data))
	}
}


export default connect(mapStateToProps,mapDispatchToProps)(MapPositionsManagement);